var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKipSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 256C384 273.688 369.688 288 352 288H205.227L339 410.5C355.312 425.406 356.406 450.719 341.5 467C333.625 475.625 322.812 480 312 480C302.344 480 292.656 476.531 285 469.5L144 340.406V440C144 462.094 126.094 480 104 480S64 462.094 64 440V288H32C14.312 288 0 273.688 0 256S14.312 224 32 224H64V72C64 49.906 81.906 32 104 32S144 49.906 144 72V171.594L285 42.5C301.219 27.625 326.594 28.688 341.5 45C356.406 61.281 355.312 86.594 339 101.5L205.227 224H352C369.688 224 384 238.312 384 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKipSign);
export default __webpack_public_path__ + "static/media/kip-sign.6489319a63399258fb7c53f7e4dd2384.svg";
export { ForwardRef as ReactComponent };